/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_EMP_LISTDATA } from "../../actions";
import Select from "react-select";
import { adminlimit } from "../Settings/Config";
import {
  showContaimerLoader,
  showStatus,
  encodeValue,
  removeEmpItem,
  hasPermission,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "employee/skill";
var modulePath = "/hrms/skill";
var moduleName = "Skill";
const moduleID = 37;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    if (!hasPermission(moduleID, "view")) {
      this.props.history.push("/search");
    } else {
      this.loadList(1);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    const params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: `${module}`,
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push(`${modulePath}/edit/${encodeValue(editID)}`);
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeEmpItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="skill" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={`${modulePath}/add`}>
                            <button
                              className="btn btn-sm btn-success badge"
                              type="button"
                            >
                              <i className="fa fa-plus"></i> Add New
                            </button>
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                    <div className="row">
                      <div className="col-md-12 col-xl-12">
                        <div className="card">
                          <div className="card-body">
                            <div className="form-row">
                              <div className="col-md-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={"Search " + moduleName}
                                  name="name"
                                  onChange={this.handleChangeText}
                                  value={this.state.name}
                                />
                              </div>

                              <div className="col-md-2">
                                <Select
                                  value={this.state.status}
                                  onChange={this.handleSelectChange.bind(
                                    this,
                                    "status"
                                  )}
                                  placeholder="Select Status"
                                  isClearable={true}
                                  options={[
                                    { value: 'A', label: "Active" },
                                    { value: 'I', label: "In Active" },
                                  ]}
                                />
                              </div>
                              <div className="col-md-3">
                                <a
                                  href={void 0}
                                  className="btn btn-primary"
                                  onClick={this.searchList.bind(this)}
                                >
                                  Search
                                </a>
                                <a
                                  href={void 0}
                                  className="btn btn-secondary offset-1"
                                  onClick={this.resetSearch.bind(this)}
                                >
                                  Reload
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th>Skill Name</th>
                                      <th>Status</th>
                                      <th className="text-center">Actions </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{item.empskillName}</td>
                                            <td>{showStatus(item.empskillStatus)}</td>
                                            <td className="text-center text-nowrap align-middle">
                                              <a
                                                href={void 0}
                                                onClick={this.edit.bind(
                                                  this,
                                                  item.empskillID
                                                )}
                                                className="me-2"
                                              >
                                                <i className="fa fa-pencil-square-o"></i>
                                              </a>
                                              <a
                                                href={void 0}
                                                className="delete_record"
                                                data="Delete"
                                                onClick={this.removeItem.bind(
                                                  this,
                                                  encodeValue(item.empskillID)
                                                )}
                                              >
                                                <i className="fa fa-trash"></i>
                                              </a>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td className="text-center" colSpan={8}>
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>

                                <Pagenation
                                  params={{
                                    totalRecords: this.state.totalRecords,
                                    totalPage: this.state.totalPage,
                                    currentPage: this.state.currentPage,
                                  }}
                                  sateValChange={this.sateValChange}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = Array();
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.emplistdata).length > 0) {
 
    if (state.emplistdata[0].success ===true) {
      listdata = state.emplistdata[0].result;
      totalPages = state.emplistdata[0].totalPage;
      totalRecords = state.emplistdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_EMP_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
